import React from "react";

const Keno = () => {
  return (
    <div className="page-container">
      <h1 style={{ color: "#f59e0b", marginBottom: "20px" }}>คีโน่</h1>
      <p style={{ fontSize: "16px", color: "#fff" }}>
        เกมคีโน่ออนไลน์ เลือกหมายเลขโชคดี
      </p>
    </div>
  );
};

export default Keno;
